// extracted by mini-css-extract-plugin
export var addToCartButton = "_sf-b";
export var arrowButtonContainer = "_sf-9";
export var arrowButtonIcon = "_sf-a";
export var carouselArrowButton = "_sf-6";
export var carouselElementContainer = "_sf-1";
export var galleryThumbnail = "_sf-d";
export var galleryThumbnailImage = "_sf-e";
export var left = "_sf-7";
export var productDisplayCarouselContainer = "_sf-0";
export var productTileContainer = "_sf-2";
export var productTileImage = "_sf-4";
export var productTileImageContainer = "_sf-3";
export var productTileTitle = "_sf-5";
export var right = "_sf-8";
export var sliderOverflow = "_sf-c";